import React, { useState, useEffect, useRef } from 'react';
import { Button, Table, Form, Spin, Select, Input, Tabs, Space } from 'antd';
import { HomeOutlined, RedoOutlined, SearchOutlined, DownloadOutlined } from '@ant-design/icons';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import trans from './translation';
import Message from '../../component/message/message';
import SelectCohortModule from './selectCohortModule';
import moment from 'moment';//日期格式化导包
import CohortProgSearchModal from './cohortProgSearchModal'
import './studentModuleRecordReport.css';

const StudentModuleRecordReport = () => {

    const messageRef = useRef();
    const [form] = Form.useForm();
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [tabIndex, setTabIndex] = useState("1");
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [downloadModel, setDownloadModel] = useState("");
    const [selected, setSelected] = useState([]);

    const [isSearchModuleModal, setIsSearchModuleModal] = useState(false);
    const [studentModel, setStudentModel] = useState({});
    const [selectedSRowKeys, setSelectedRowKeys] = useState([]);
    const [isSearchCohortProgModal, setIsSearchCohortProgModal] = useState(false);
    const [cohortProgModel, setCohortProgModel] = useState({});
    
    const tableColumns = {
        segmentName: "short_desc",
        code: "code",
        dispSeq: "disp_seq"
    }

    useEffect(() => {
        search(pageSize, 1, "N");
    }, []);


    const searchChange = (key, value) => {
        messageShowHandler();
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    const search = (pageSizeNew, currentPageNew, flag, isShowMsg) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();  // 清除提示信息
        let model = {};
        if ("Y" === flag) {     // 翻页
            model = oldSearchModel;
        } else {
            model = searchModel;
        }
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        model.progCodeList = Config.userInfo?.progCodeList;
        setDownloadModel(model)
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("studentModuleRecord/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(() => { }).finally(() => setIsLoad(false));
    }

    const reset = () => {
        messageShowHandler();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
        setSelectedRowKeys([])
        setSelected([])
        setCohortProgModel({});
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const selectCohortModuleClose = (flag, model) => {
        if (flag) {
            if (tabIndex === "1") {
                setSearchModel(model1 => {
                    return { ...model1, ...{ moduleCode: model.moduleCode } };
                });
            } else {
                setStudentModel({
                    ...studentModel, ...{
                        moduleCode: model.moduleCode,
                        moduleName: model.moduleName,
                        cohortModuleId: model.cohortModuleId,
                        progCode: model.progCode ?? "",
                        progTitle: model.progTitle ?? '',
                        cohortId: model.progTitle ?? '',
                    }

                })
                form.setFieldsValue({
                    moduleCode: model.moduleCode ?? "",
                    moduleName: model.moduleName ?? '',
                    progCode: model.progCode ?? "",
                    progTitle: model.progTitle ?? '',
                    cohortId: model.cohortId ?? '',
                    academicSupervisorUserId: ""
                });
            }
        }
        setIsSearchModuleModal(false);
    }

    const closeSearchCohortProgModal = (flag, cohortProg) => {
        if (flag) {
            setSearchModel(model => {
                return { ...model, ...{ progName: cohortProg.progTitle, progCode: cohortProg.progCode, cohortProgId: cohortProg.cohortProgId} };
            });
            setCohortProgModel(cohortProg);
        }
        setIsSearchCohortProgModal(false);
    }

    const downloadExcel = () => {
        messageShowHandler();//清空提示信息
        setIsLoad(true);
        setSpinInfo(trans.download[Config.backLang])
        const filename = "Enrolled Module Student Record Report" + moment(new Date()).format(Config.dateFormat3) + Base.generateFourDigitRandomNumber() + ".xlsx"
        fetch(Config.apiDownloadServer + "studentModuleRecord/exportReport", {
            method: 'POST',
            body: JSON.stringify(downloadModel),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.blob()).then(blob => {
            if (blob.type == "application/json") {
                var reader = new FileReader();
                reader.onload = e => {
                    var data = JSON.parse(e.target.result);
                    errFrameShow("error", data.msg);
                }
                reader.readAsText(blob);
            } else {
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {// for IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {// for Non-IE (chrome, firefox etc.)
                    var a = document.createElement('a');
                    document.body.appendChild(a);
                    a.style = 'display: none';
                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = filename
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                }
            }
        }).catch(err => ({ err })).finally(() => {
            setIsLoad(false)
        });
    }

    const columns = [
        {
            title: "Cohort",
            dataIndex: 'cohortYear',
            className: 'tableWidth2',
        },
        {
            title: "Semester",
            dataIndex: 'semester',
            className: 'tableWidth3',
        },
        {
            title: "Student ID",
            dataIndex: 'studentAcctId',
            className: 'tableWidth4',
        },
        {
            title: "Student Name",
            dataIndex: 'firstName',
            className: 'tableWidth4',
            render: (text, record) => (record?.firstName ?? '') + ' ' + (record?.lastName ?? '')
        },
        {
            title: "Module Code",
            dataIndex: 'moduleCode',
            className: 'tableWidth5',
        },
        {
            title: "Module Name",
            dataIndex: 'moduleName',
            className: 'tableWidth5',
        },
        {
            title: "Programme Code",
            dataIndex: 'progCode',
            className: 'tableWidth5',
        },
        {
            title: "Programme Name",
            dataIndex: 'progTitle',
            className: 'tableWidth5',
        },
        {
            title: "Assigned-AS",
            dataIndex: 'staffName',
            className: 'tableWidth4',
        },
        {
            title: "Sub Group",
            dataIndex: 'group',
            className: 'tableWidth3',
        },
        {
            title: '# of WIL Hours Completed',
            dataIndex: 'completedWilHours',
            className: 'tableWidth6',
        },
        {
            title: "Assignment 1",
            dataIndex: 'assignMarks',
            className: 'tableWidth305',
            render: (text, record) => {
                let model = record?.studentModuleAssignModelList?.find(item => item.assignSeq == 1);
                return model ? Base.numberReplaceSymbol(model?.assignMarks, "Incomplete") : "N/A";
            }
        },
        {
            title: "Assignment 2",
            dataIndex: 'assignMarks',
            className: 'tableWidth305',
            render: (text, record) => {
                let model = record?.studentModuleAssignModelList?.find(item => item.assignSeq == 2);
                return model ? Base.numberReplaceSymbol(model?.assignMarks, "Incomplete") : "N/A";
            }
        },
        {
            title: "Assignment 3",
            dataIndex: 'assignMarks',
            className: 'tableWidth305',
            render: (text, record) => {
                let model = record?.studentModuleAssignModelList?.find(item => item.assignSeq == 3);
                return model ? Base.numberReplaceSymbol(model?.assignMarks, "Incomplete") : "N/A";
            }
        },
        {
            title: "Assignment 4",
            dataIndex: 'assignMarks',
            className: 'tableWidth305',
            render: (text, record) => {
                let model = record?.studentModuleAssignModelList?.find(item => item.assignSeq == 4);
                return model ? Base.numberReplaceSymbol(model?.assignMarks, "Incomplete") : "N/A";
            }
        },
        {
            title: "Assignment 5",
            dataIndex: 'assignMarks',
            className: 'tableWidth305',
            render: (text, record) => {
                let model = record?.studentModuleAssignModelList?.find(item => item.assignSeq == 5);
                return model ? Base.numberReplaceSymbol(model?.assignMarks, "Incomplete") : "N/A";
            }
        },
        {
            title: "Assignment 6",
            dataIndex: 'assignMarks',
            className: 'tableWidth305',
            render: (text, record) => {
                let model = record?.studentModuleAssignModelList?.find(item => item.assignSeq == 6);
                return model ? Base.numberReplaceSymbol(model?.assignMarks, "Incomplete") : "N/A";
            }
        },
        {
            title: "Assignment 7",
            dataIndex: 'assignMarks',
            className: 'tableWidth305',
            render: (text, record) => {
                let model = record?.studentModuleAssignModelList?.find(item => item.assignSeq == 7);
                return model ? Base.numberReplaceSymbol(model?.assignMarks, "Incomplete") : "N/A";
            }
        },
        {
            title: "Assignment 8",
            dataIndex: 'assignMarks',
            className: 'tableWidth305',
            render: (text, record) => {
                let model = record?.studentModuleAssignModelList?.find(item => item.assignSeq == 8);
                return model ? Base.numberReplaceSymbol(model?.assignMarks, "Incomplete") : "N/A";
            }
        },
        {
            title: "Assignment 9",
            dataIndex: 'assignMarks',
            className: 'tableWidth305',
            render: (text, record) => {
                let model = record?.studentModuleAssignModelList?.find(item => item.assignSeq == 9);
                return model ? Base.numberReplaceSymbol(model?.assignMarks, "Incomplete") : "N/A";
            }
        },
        {
            title: "Assignment 10",
            dataIndex: 'assignMarks',
            className: 'tableWidth405',
            render: (text, record) => {
                let model = record?.studentModuleAssignModelList?.find(item => item.assignSeq == 10);
                return model ? Base.numberReplaceSymbol(model?.assignMarks, "Incomplete") : "N/A";
            }
        },
        {
            title: "WPA Weight Adjusted",
            dataIndex: 'wpaAdjustWeightCount',
            className: 'tableWidth5',
            render: text => text > 0 ? 'Y' : 'N'
        },
        {
            title: "WPA Mark",
            dataIndex: 'wpaMarks',
            className: 'tableWidth3',
            render: (text) => Base.numberReplaceSymbol(text, "N/A")
        },
        {
            title: "Total Module Mark",
            dataIndex: 'totalModuleMark',
            className: 'tableWidth5',
            render: (text) => Base.numberReplaceSymbol(text, "N/A")
        },
        {
            title: 'Grade',
            dataIndex: 'totalModuleMark',
            className: 'tableWidth2',
            render: (text) => (text || text == 0) && Base.calcGrade(text)
        },
        {
            title: "Status",
            dataIndex: 'status',
            className: 'tableWidth3',
            render: (text) => ContextHandler.getMapValue('studentModuleStatusMap', text)
        },
    ];

    return (
        <div id="container" className="template studentModuleRecordReport">
            <div className='breadcrumb'>
                <HomeOutlined /> / Setup / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : (Config.backLang === 'EN' ? 'En' : ''))]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin spinning={isLoad} size="large" tip={spinInfo}>
                    <div className='sysRow'>
                        <div className='sysCol'>
                            <div className="sysTitle">Student Name</div>
                            <div className="sysSerchInput">
                                <Input type="text" value={searchModel.firstName || ''}
                                    placeholder="Student Name"
                                    onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                    onChange={(e) => searchChange('firstName', e.target.value)} />
                            </div>
                        </div>
                        <div className='sysCol'>
                            <div className="sysTitle">Student ID</div>
                            <div className="sysSerchInput">
                                <Input type="text" value={searchModel.studentAcctId || ''}
                                    placeholder="Student ID"
                                    onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                    onChange={(e) => searchChange('studentAcctId', e.target.value)} />
                            </div>
                        </div>
                        <div className='sysCol'>
                            <div className="sysTitle">Module</div>
                            <div className="sysButtonSearchInput">
                                <Input type="text" value={searchModel.moduleCode || ''} disabled
                                    placeholder="Module"
                                    onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                    onChange={(e) => searchChange('moduleCode', e.target.value)} />
                            </div>
                            <Button className="sysBtn btnBlue" onClick={() => { setIsSearchModuleModal(true) }}>Select</Button>
                            {searchModel.moduleName && <div style={{ marginLeft: '10px' }}>{searchModel.moduleName}</div>}
                        </div>
                    </div>
                    <div className='sysRow'>
                        <div className='sysCol'>
                            <div className="sysTitle">Programme </div>
                            <div className="sysButtonSearchInput">
                                <Input type="text" value={searchModel.progCode || ''} disabled
                                    placeholder="Programme "
                                    onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                    onChange={(e) => searchChange('progCode', e.target.value)} />
                            </div>
                            <Button className="sysBtn btnBlue" onClick={() => { setIsSearchCohortProgModal(true) }}>Select</Button>
                            {searchModel.progName && <div style={{ marginLeft: '10px' }}>{searchModel.progName}</div>}
                        </div>
                        <div className='sysCol'>
                            <div className="sysTitle">Assigned-AS</div>
                            <div className="sysSerchInput">
                                <Input type="text" value={searchModel.staffName || ''}
                                    placeholder="Assigned-AS"
                                    onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                    onChange={(e) => searchChange('staffName', e.target.value)} />
                            </div>
                        </div>
                        <div className='sysSearchButton'>
                            <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                            <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                        </div>
                    </div>
                    <div className="sysLineEight"></div>
                    <Space size={[5, 5]} wrap className="sysButtonRelative">
                    {tables.length == 0 ? null :
                        <>
                            <Button className="sysBtn btnBlue" type="primary" onClick={downloadExcel} hidden={Config.funcInfo.canDownload === "N"} icon={<DownloadOutlined />}>Export</Button>
                        </>
                    }
                    </Space>
                    <div className="sysTable" id="tableOne">
                        <Table
                            rowKey="studentModuleId"
                            scroll={{ x: 3500 }}
                            columns={columns} //列名
                            dataSource={tables} //数据
                            pagination={{  //分页
                                showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                onChange: onChange,            //上页下页或者跳页方法
                                onShowSizeChange: onShowSizeChange,    //每页显示多少条数据方法
                                total: tablesCount,             //总共多少条数据
                                current: current,         //当前页
                                pageSize: pageSize,       //每页显示多少条数据
                                defaultCurrent: 1,                               //默认当前页为1
                                size: "small"
                            }}
                            onChange={handleTableChange}
                        />
                    </div>
                </Spin>
            </div>
            {isSearchModuleModal && <SelectCohortModule onClose={selectCohortModuleClose} />}
            {isSearchCohortProgModal && <CohortProgSearchModal onClose={closeSearchCohortProgModal} />}
        </div>
    )

}

export default StudentModuleRecordReport;